import { render } from "./DeliveryDetails.vue?vue&type=template&id=1f28db7a&scoped=true"
import script from "./DeliveryDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryDetails.vue?vue&type=script&lang=js"

import "./DeliveryDetails.vue?vue&type=style&index=0&id=1f28db7a&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f28db7a"]])

export default __exports__